export default {
  title: "Support",
  payments: "For all questions regarding payouts, please email {finance_email}.",
  spam: 'Important: please check your "Spam" folder!',
  other: "For all other questions, please use the form below.",
  faq: "frequently asked questions",
  faq_notice:
    "Before submitting a request, please review our rules and the {faq} (FAQ) section — the answer may already be there.",
  response_time:
    "A response may take from 12 hours up to 2 business days, depending on the complexity of the request and the current workload of the support team."
};
